import type { PersonKurz } from "../personen";
import { anzeigename } from "../namen";
import { Avatar } from "./Avatar";
import { stapelTeile } from "../stapel";
import s from "./auswahl.module.css";

/** Köpfe der Verantwortlichen. Namen als title und für Screenreader als Text. Ohne Personen ein leerer Kreis „Offen“. */
export function Stapel({ personen, groesse = 28 }: { personen: readonly (PersonKurz | undefined)[]; groesse?: number }) {
  const bekannt = personen.filter((p): p is PersonKurz => !!p);
  const namen = bekannt.map((p) => p.vorname || anzeigename(p)).join(", ");
  if (bekannt.length === 0) {
    return (
      <span className={s.stapel} title="Offen">
        <span className={s.offenKreis} style={{ width: groesse, height: groesse }} aria-hidden="true" />
        <span className="nur-leser">Offen</span>
      </span>
    );
  }
  const { koepfe, mehr } = stapelTeile(bekannt.length);
  return (
    <span className={s.stapel} title={namen}>
      {bekannt.slice(0, koepfe).map((p) => (
        <span key={p.id} className={s.kopf}>
          <Avatar person={p} groesse={groesse} />
        </span>
      ))}
      {mehr > 0 ? (
        <span className={[s.kopf, s.mehr].join(" ")} style={{ width: groesse, height: groesse }} aria-hidden="true">
          +{mehr}
        </span>
      ) : null}
      <span className="nur-leser">{namen}</span>
    </span>
  );
}
